import React, { Component } from "react"; //eslint-disable-line
import { version } from "../../../package.json";
import { Ability } from "@casl/ability";
import axios from "axios";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";
import { Link } from "react-router-dom";
class DefaultFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ability: new Ability([]),
    };
  }

  async getAbility() {
    try {
      const { data } = await axios.get(`${API_ENDPOINTS.ROLES}/abilities`);
      this.setState({ ability: new Ability(data) });
    } catch (error) {
      console.error(error);
    }
  }

  componentDidMount() {
    this.getAbility();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.ability !== this.props.ability) {
      this.getAbility();
    }
  }

  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <Link to="/release">{`v${version} Klimator IoT Platform`}</Link>
      </React.Fragment>
    );
  }
}

export default DefaultFooter;
